import { $, $$ } from "@utils/dom";
import { on, off } from "@utils/listener";

class PostPreview {
  constructor(el) {
    this.el = el;

    this.links = [ ...$$('[data-post-preview-link]', this.el) ];

    this._enterLink = this._enterLink.bind(this);
    this._leaveLink = this._leaveLink.bind(this);
  }

  destroy() {

    this.el = null;

    this.links = null;
  }

  start() { this._bindEvents(); }
  stop() { this._unbindEvents(); }

  _bindEvents() {
    if(this.links) {
      on(this.links, 'mouseenter', this._enterLink);
      on(this.links, 'mouseleave', this._leaveLink);
    }
  }
  _unbindEvents() {
    if(this.links) {
      off(this.links, 'mouseenter', this._enterLink);
      off(this.links, 'mouseleave', this._leaveLink);
    }
  }

  _enterLink(){
    this.el.classList.add('--hover');
  }

  _leaveLink(){
    this.el.classList.remove('--hover');
  }
}

export default PostPreview;
